/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Daterangepicker_Selectdaterange4Inputs */

const id_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih rentang tanggal`)
};

const ms_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih julat tarikh`)
};

const da_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg datointerval`)
};

const de_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datumsbereich wählen`)
};

const en_us2_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select date range`)
};

const es_es2_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un rango de fechas`)
};

const es_mx2_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar rango de fechas`)
};

const fil_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng date range`)
};

const fr_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner une plage de dates`)
};

const it_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona intervallo date`)
};

const hu_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dátumtartomány kiválasztása`)
};

const nl_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer datumbereik`)
};

const no_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg datoområde`)
};

const pl_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz zakres dat`)
};

const pt_br2_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar período`)
};

const pt_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar intervalo de datas`)
};

const ro_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectează intervalul de date`)
};

const fi_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse päivämääräväli`)
};

const sv_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj datumintervall`)
};

const vi_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn phạm vi ngày`)
};

const tr_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarih aralığı seç`)
};

const cs_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat rozsah dat`)
};

const bg_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете диапазон от дати`)
};

const ru_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать диапазон дат`)
};

const uk_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вибрати діапазон дат`)
};

const ar_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر نطاق التاريخ`)
};

const hi_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तारीख़ सीमा चुनें`)
};

const th_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกช่วงวันที่`)
};

const ja_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付範囲を選択`)
};

const zh_cn2_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择日期范围`)
};

const zh_hant1_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇日期範圍`)
};

const ko_components_daterangepicker_selectdaterange4 = /** @type {(inputs: Components_Daterangepicker_Selectdaterange4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`날짜 범위 선택`)
};

/**
* | output |
* | --- |
* | "Select date range" |
*
* @param {Components_Daterangepicker_Selectdaterange4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_daterangepicker_selectdaterange4 = /** @type {((inputs?: Components_Daterangepicker_Selectdaterange4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Daterangepicker_Selectdaterange4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "ms") return ms_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "da") return da_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "de") return de_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "en-US") return en_us2_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "es-ES") return es_es2_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "es-MX") return es_mx2_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "fil") return fil_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "fr") return fr_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "it") return it_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "hu") return hu_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "nl") return nl_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "no") return no_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "pl") return pl_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "pt-BR") return pt_br2_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "pt") return pt_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "ro") return ro_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "fi") return fi_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "sv") return sv_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "vi") return vi_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "tr") return tr_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "cs") return cs_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "bg") return bg_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "ru") return ru_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "uk") return uk_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "ar") return ar_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "hi") return hi_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "th") return th_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "ja") return ja_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "zh-CN") return zh_cn2_components_daterangepicker_selectdaterange4(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_daterangepicker_selectdaterange4(inputs)
	return ko_components_daterangepicker_selectdaterange4(inputs)
});
export { components_daterangepicker_selectdaterange4 as "components.dateRangePicker.selectDateRange" }